import React from 'react'
import { useStake } from '../../../../hooks/useMyStakes';

function TotalStaked({ contract }) {
    const { stakes, loading, error, refetch } = useStake(contract, 18);

  return (
      <div>{stakes?.total?.readable}</div>
  )
}

export default TotalStaked